import React, { useEffect, useState, useRef } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, fetch, post, postForm } from "../../Util/axios_helper";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  getGoalList,
  getGoalTypesDropList,
  getMonthWeekDropList,
  onGoalEdit,
} from "../Email/configuration_slice";
import { KendoLoader } from "../../Kendo/kendo_loader";
import {
  Button,
  ErrorMsg,
  GetFormData,
  Loader,
  ValidateForm,
  checkAccess,
  confirmDelete,
} from "../../Util/common";

export const Goal = ({ selTab }) => {
  const dispatch = useDispatch();
  const {
    goalList,
    goalListLoaded,
    monthWeekDropList,
    goalTypeDropList,
    selGoalType,
    selMonthWeek,
  } = useSelector((state) => state.configuration);
  const [error, setError] = useState({});
  const [editVisible, setEditVisible] = useState(false);
  const [goalName, setGoalName] = useState("");
  const [goalType, setGoalType] = useState("");
  const [monthWeek, setMonthWeek] = useState("");
  const [Loading, setLoading] = useState(false);
  const modalRef = useRef(null);
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setGoalName("");
    setError({});
    dispatch(onGoalEdit(null));
    setEditVisible(false);
  };

  useEffect(() => {
    if (selTab == 6) {
      dispatch(getGoalList());
      dispatch(getMonthWeekDropList());
      dispatch(getGoalTypesDropList());
      if (modalRef.current) {
        $(modalRef.current).on("hidden.bs.modal", () => {
          clearForm();
        });
      }

      return () => {
        if (modalRef.current) {
          $(modalRef.current).off("hidden.bs.modal");
        }
      };
    }
  }, [selTab]);

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      setLoading(true);
      var data = GetFormData(e);
      if (editVisible && editVisible.visible) {
        data.GoalId = editVisible.goalId;
      }
      try {
        if (editVisible && editVisible.visible) {
          await post("Configuration/SaveGoal", data, true, false, false, true);
        } else {
          await post("Configuration/SaveGoal", data, true, true, false, false);
        }
        clearForm();
        $("#ballroom-goal-cancel").click();
        dispatch(getGoalList());
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleEditClick = async (e) => {
    const data = await fetch(`Configuration/GetGoalById?GoalId=${e.GoalId}`);
    dispatch(onGoalEdit(data));

    setGoalName(data.GoalNo);

    setEditVisible({
      visible: true,
      goalId: e.GoalId,
    });
    const modal = new bootstrap.Modal(document.getElementById("add_goal"));
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      fetch(
        `Configuration/DeleteGoal?GoalId=${e.GoalId}`,
        true,
        false,
        true
      ).then(() => {
        dispatch(getGoalList());
      });
    };
    confirmDelete(onDelete);
  };

  return (
    <>
      <div className="col-auto ms-auto">
        <div className="row">
          <div className="col-sm-6"></div>
          {checkAccess("APPCONFIGCREATE") && (
            <div className="col-auto float-end ms-auto">
              <div className="d-flex justify-content-end mb-2">
                <Button
                  name={"Add Goal"}
                  dataBsToggle={"modal"}
                  dataBsTarget={"#add_goal"}
                  dataBsDismiss={"modal"}
                />
              </div>
            </div>
          )}
        </div>

        <div>
          {!goalListLoaded ? (
            <div className="row">
              {" "}
              <div className="col-12">
                <KendoLoader />
              </div>
            </div>
          ) : (
            <KendoGrid
              name={"goal-config"}
              data={goalList}
              schema={{}}
              columns={[
                {
                  field: "GoalId",
                  filterable: false,
                  hidden: true,
                },

                {
                  field: "GoalTypeName",
                  title: "Goal Type",
                },
                {
                  field: "MonthWeekName",
                  title: "Month/Week",
                },
                {
                  template: function (e) {
                    if (e.GoalNo) {
                      const hasDecimal = e.GoalNo.toString().includes(".");
                      const formattedValue = e.GoalNo.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: hasDecimal ? 2 : 0,
                        maximumFractionDigits: hasDecimal ? 2 : 0,
                      });
                      return formattedValue;
                    }
                    return "";
                  },
                  field: "GoalNo",
                  title: "Goal",
                },
                {
                  field: "CreatedDate",
                  title: "Created Date",
                  template:
                    "#= kendo.toString(new Date(CreatedDate), 'MM/dd/yyyy') #",
                },
              ]}
              showOptions={
                checkAccess("APPCONFIGEDIT") || checkAccess("APPCONFIGDELETE")
              }
              showEdit={checkAccess("APPCONFIGEDIT")}
              showDelete={checkAccess("APPCONFIGDELETE")}
              onEditClick={(e) => handleEditClick(e)}
              onDeleteClick={(e) => {
                handleDeleteClick(e);
              }}
              disableExportExcel={true}
            />
          )}
        </div>
      </div>
      {/* <!-- Add goal Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_goal"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Goal" : "Add Goal"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-goal-config" onSubmit={onSubmit}>
                <div className="input-block mb-3">
                  <label className="form-label">
                    Goal Type <span className="text-danger">*</span>
                  </label>
                  <KendoDropdown
                    name="GoalTypeId"
                    data={goalTypeDropList}
                    placeholder={"Select Goal Type"}
                    dataTextField={"GoalTypeName"}
                    dataValueField={"GoalTypeId"}
                    value={selGoalType}
                    required={true}
                    onValidate={onValidation}
                  />
                  {error.GoalTypeId && (
                    <ErrorMsg text="Goal type is required" />
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="form-label">
                    Month/Week <span className="text-danger">*</span>
                  </label>
                  <KendoDropdown
                    name="MonthWeekId"
                    data={monthWeekDropList}
                    placeholder={"Select Month/Week"}
                    dataTextField={"MonthWeekName"}
                    dataValueField={"MonthWeekId"}
                    value={selMonthWeek}
                    required={true}
                    onValidate={onValidation}
                  />
                  {error.MonthWeekId && (
                    <ErrorMsg text="Month/Week is required" />
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="form-label">
                    Goal <span className="text-danger">*</span>
                  </label>

                  <div class="input-group">
                    <span class="input-group-text field" id="sizing-addon2">
                      $
                    </span>
                    <input
                      type="text"
                      name="GoalNo"
                      class="form-control field"
                      placeholder="Goal"
                      aria-describedby="sizing-addon2"
                      autoComplete="off"
                      maxLength={7}
                      value={goalName}
                      data-required="true"
                      onChange={(e) => {
                        let enteredValue = e.target.value;
                        if (/^\d*\.?\d*$/g.test(enteredValue)) {
                          setGoalName(e.target.value);
                          onValidation("goalName", e.target.value);
                        }
                      }}
                    />
                  </div>
                  {error.GoalNo &&
                    (error.Zero ? (
                      <ErrorMsg text="Please give more than 0" />
                    ) : (
                      <ErrorMsg text="Goal is required" />
                    ))}
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="ballroom-goal-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
